import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import './App.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from './axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShareEvent from './Event/ShareEvent';
import NoEventImg from '../src/img/events/no-events.png'
import NoEventImgLight from '../src/img/events/no-events-light.png'
import EventView from '../src/img/events/event-view.jpg'

import hassleFree from '../src/img/quick-filter/hassleFree.png'
import hostFree from '../src/img/quick-filter/hostFree.png'
import lowFees from '../src/img/quick-filter/lowFees.png'

import liveShow from '../src/img/quick-filter/liveShow.png'
import beer from '../src/img/quick-filter/beer.png'
import fitness from '../src/img/quick-filter/fitness.png'
import music from '../src/img/quick-filter/music.png'
import food from '../src/img/quick-filter/food.png'
import sports from '../src/img/quick-filter/sports.png'

import partiesEvents from '../src/img/nw-category-imgs/parties-events.png'
import musicEvents from '../src/img/nw-category-imgs/music-events.png'
import agricultureEvents from '../src/img/nw-category-imgs/agriculture-events.png'
import sportsEvents from '../src/img/nw-category-imgs/sports-events.png'
import CampingEvents from '../src/img/nw-category-imgs/camping.png'
import runningEvents from '../src/img/nw-category-imgs/running-events.png'
import kiteFestEvents from '../src/img/nw-category-imgs/Kite-Fest.png'


const FeaturedEvents = (props) => {
  // const navigate = useNavigate();
  const [ShareEventFlag, setShareEventFlag] = useState(false);
  const [EventName, setEventName] = useState('');
  const [EventIdShareEvent, setEventIdShareEvent] = useState('');
  const navigate = useNavigate();
 
  const [ConditionFlag, setConditionFlag] = useState(0);
  const [WishListFlag, setWishListFlag] = useState(false);
  const [EventsData, setEventsData] = useState([]);
  // console.log(eventsData);

  const handleWishList = (eventId, is_follow) => {
    const RacesToken = localStorage.getItem("RacesToken") ? localStorage.getItem("RacesToken") : "";
    if (RacesToken) {
      const payload = {
        "event_id": eventId,
        "is_follow": is_follow
      }
      axios.post("/follow", payload)
        .then((response) => {
          // console.log(response.data.message);
          if (response.status === 200) {
            toast.success(response.data.message);
            props.setSearchFlag('HeaderInputCity');
            props.setHeaderInputCity(localStorage.getItem("CityId"))
            setWishListFlag(true);
          }
        })
        .catch((error) => {
          if (error.response) {
            console.log('Error occured while adding to wishlist')
          }
        })
    } else {
      // console.log("token is not available");
      props.setLoginWishlist(true);
      // props.setOpen(true);
    }
  }

  useEffect(() => {
    if (WishListFlag) {
      // console.log("CitySearch call : ", SearchFlag);
      const payload = {
        country: "India",
        country_code: "in",
        city: "",
        state: "",
        scity: "",
        sstate: "",
        scountry: "",
        home_flag: 1
      }
      // console.log(payload);
      axios.post("get_banner_events", payload)
        .then((response) => {
          // console.log(response.data.data.UpcomingEventData);
          setEventsData(response.data.data.FeaturedEventData);
          window.location.reload();
          setWishListFlag(false);
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }, [WishListFlag])
//  console.log(EventsData);
  const eventsData = props.FeaturedEventData || EventsData;
  const showDots = eventsData.length > 4 ? true : eventsData.length > 4;

  const handleShareEvent = (eventId, eventName) => {
    setShareEventFlag(true);
    setEventName(eventName);
    setEventIdShareEvent(eventId);
  }

  const handleSearchPage = (e) => {
    navigate('/events', { state: { 'from_popular_events': 1, 'popular_events': eventsData } });
  }

  const CustomPrevArrow = (props) => {
    const { onClick, currentSlide } = props;
    // console.log(currentSlide);
    return (
      <button
        onClick={onClick}
        className={`swiper__nav--btn swiper-button-prev ${currentSlide === 0 ? 'hidden' : ''}`}
        tabIndex="0" aria-label="Previous slide" aria-controls="swiper-wrapper-1a836b27912729b1"
      >
        {/* <FaArrowLeft /> */}
      </button>
    );
  };

  // const CustomNextArrow = (props) => {
  //   const { onClick, currentSlide, slideCount } = props;
  //   const viewAllLimit = slideCount > 4 ?  slideCount - 4 :  slideCount;
  //   // console.log(currentSlide, slideCount);
  //   if (currentSlide < viewAllLimit) {
  //     return (
  //       <button
  //         onClick={onClick}
  //         className={`swiper__nav--btn swiper-button-next  ${currentSlide === (slideCount - 4) ? 'hidden' : ''} || ${slideCount < 4 ? 'hidden' : ''}`}
  //         tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
  //       >
  //         {currentSlide !== (slideCount - 4)}
  //       </button>
  //     );
  //   } else if(currentSlide === viewAllLimit) {
  //     return (
  //       <button
  //         onClick={(e) => handleSearchPage(e)}
  //         className={`swiper__nav--btn swiper-button-next view-all-btn  ${currentSlide === (slideCount ) ? 'hidden' : ''} || ${slideCount === 4 ? 'hidden' : ''}`}
  //         tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
  //       >View All &nbsp;</button>
  //     );
  //   }
  //   // else {
  //   //   return (
  //   //     <button
  //   //       onClick={(e) => handleSearchPage(e)}
  //   //       className={`swiper__nav--btn swiper-button-next view-all-btn  ${currentSlide === (slideCount - 4) ? 'hidden' : ''} || ${slideCount < 4 ? 'hidden' : ''}`}
  //   //       tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
  //   //     >View All &nbsp;</button>
  //   //   );
  //   // }

  // };

  const CustomNextArrow = (props) => {

    // console.log(currentSlide, slideCount);

    if (window.innerWidth < 550) {
      const { onClick, currentSlide, slideCount } = props;
      const viewAllLimit = slideCount > 4 ? slideCount - 4 : slideCount;
      // console.log(currentSlide, slideCount, viewAllLimit); //0 5 1
      const noCount = (eventsData.length);
      if (currentSlide + 1 < noCount) {
        return (
          <button
            onClick={onClick}
            className={`swiper__nav--btn swiper-button-next  ${currentSlide === (noCount - 1) ? 'hidden' : ''} || ${slideCount < eventsData.length ? 'hidden' : ''}`}
            tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
          >
            {/* {currentSlide !== (slideCount - 4)} */}
          </button>
        );
      } else if (viewAllLimit !== 1) {  //if (currentSlide === viewAllLimit)
        return (
          <button
            onClick={(e) => handleSearchPage(e)}
            className={`swiper__nav--btn swiper-button-next view-all-btn` }
            tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
          >View All &nbsp;</button>
        );
      } else {
        return (
          <button
            onClick={(e) => handleSearchPage(e)}
            className={`swiper__nav--btn swiper-button-next view-all-btn`}
            tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
          >View All &nbsp;</button>
        );
      }
    } else {
      const { onClick, currentSlide, slideCount } = props;
      const viewAllLimit = slideCount > 4 ? slideCount - 4 : slideCount;
      if (currentSlide < viewAllLimit) {
        return (
          <button
            onClick={onClick}
            className={`swiper__nav--btn swiper-button-next  ${currentSlide === (slideCount - 4) ? 'hidden' : ''} || ${slideCount < 4 ? 'hidden' : ''}`}
            tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
          >
            {currentSlide !== (slideCount - 4)}
          </button>
        );
      } else if (currentSlide === viewAllLimit) {
        return (
          <button
            onClick={(e) => handleSearchPage(e)}
            className={`swiper__nav--btn swiper-button-next view-all-btn  ${currentSlide === (slideCount) ? 'hidden' : ''} || ${slideCount === 4 ? 'hidden' : ''}`}
            tabIndex="0" aria-label="Next slide" aria-controls="swiper-wrapper-1a836b27912729b1"
          >View All &nbsp;</button>
        );
      }
    }

  };

  // console.log(eventsData.length);
  // const settings = {
  //   // dots: true,
  //   dots: eventsData.length > 4 ? true : false,
  //   // dots: showDots,
  //   infinite: false,
  //   speed: 500,
  //   slidesToShow: Math.min(eventsData.length, 4), // Set slidesToShow dynamically
  //   slidesToScroll: 1,
  //   responsive: [
  //     {
  //       breakpoint: 1024,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 600,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 480,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1
  //       }
  //     }
  //   ],
  //   nextArrow: <CustomNextArrow />,
  //   prevArrow: <CustomPrevArrow />,
  // };

  let dotVal = eventsData && eventsData.length > 0 ? (eventsData.length - 1) : 0;
  // console.log(dotVal);
  const settings = {
    // dots: true, eventsData.length > dotVal
    //dots: window.innerWidth > 550 ? true : (window.innerWidth < 550 && eventsData.length <= 4) ? true : false,
    dots: eventsData.length > dotVal ? true : false,
    infinite: false,
    speed: 500,
    slidesToShow: Math.min(eventsData.length, 4), // Set slidesToShow dynamically || window.innerWidth > 550
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ],
    nextArrow: <CustomNextArrow />,
    prevArrow: <CustomPrevArrow />,
  };
  // console.log(eventsData);
  var HeaderCity = "India";
  if (((localStorage.getItem("City") === 'undefined') || (localStorage.getItem("City") === "") || (localStorage.getItem("City") === null)) && (localStorage.getItem("Country") !== "")) {
    // console.log("object", localStorage.getItem("City"));
    HeaderCity = localStorage.getItem("Country");
  } else {
    HeaderCity = localStorage.getItem("City");
  }

  const handleEventDetails = (e, EventId, EventName) => {
        // navigate('/event_details', { state: { event_id: EventId } })
        // let isPassiloStaging = window.location.pathname.includes("passilo_staging");
        // if(isPassiloStaging){
        //     navigate("/passilo_staging/e/"+EventName.replace(/\s/g, '_'));
        // }else{
        //     navigate("/e/"+EventName.replace(/\s/g, '_'));
        // }
        navigate("/e/"+EventName.replace(/\s/g, '_'));
  }

  const handleCategoryDetails = (e, CategoryId, CategoryName) => {
    // console.log(CategoryId);
      navigate('/events', { state: { category_id: CategoryId, category_name: CategoryName, city_id: localStorage.getItem("CityId") ? localStorage.getItem("CityId") : 0 } }); 
  }

  const changeNavbar = () => {
    //  console.log(window.innerWidth,upcomingeventsData.length);
    if (window.innerWidth <= 550) {
      setConditionFlag(1);
    } else if (eventsData.length <= 4) {
      setConditionFlag(0);
    } else {
      setConditionFlag(1);
    }
  };

  React.useEffect(() => {
    // console.log(window.innerWidth,upcomingeventsData.length);
    if (window.innerWidth <= 550) {
      setConditionFlag(1);
    } else if (eventsData.length <= 4) {
      setConditionFlag(0);
    } else {
      setConditionFlag(1);
    }
  }, [eventsData]);

  window.addEventListener('resize', changeNavbar);

  // const words = [
  //   "Discover",
  //   "Join",
  //   "Book",
  //   "Browse",
  //   "Plan",
  //   "Don’t miss"
  // ];

  // const [index, setIndex] = React.useState(0);

  // React.useEffect(() => {
  //   const interval = setInterval(() => {
  //     setIndex((prev) => (prev + 1) % words.length);
  //   }, 4000);

  //   return () => clearInterval(interval);
  // }, []);

  const SearchFilter = () => {
    navigate('/events', { state: { "filter_name": '', "filter": '', "featured_event": 1 } });
  };
  return (
    <>
      {/* <ToastContainer theme="colored" /> */}
      {ShareEventFlag ? <ShareEvent setShareEventFlag={setShareEventFlag} EventName={EventName} EventIdShareEvent={EventIdShareEvent} /> : null}

     {/* {console.log(props.CategoryData)} */}

      {/* <section className="nw-category-section py-5">
        <div className="container">
          <h2 className="text-center d-flex align-items-center justify-content-center fw-normal">
            <span
              key={index}
              className="fw-bold typewriter"
              style={{ "--chars": words[index].length }}
            >
              {words[index]}
            </span>{" "} your next event.
          </h2>
        </div>
      </section> */}

      {/* col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 */}

      {/* {console.log(props.CategoryData)} */}
      {/* temp commented on 25-02-26 */}
      <section className="nw-category-section py-4 d-none">
        <div className="container">
          <div className="row g-3">
            <div className="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4 col-xxl-4 col-anim w-lg-4 heroCard" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[0]?.id , Array.isArray(props.CategoryData) && props.CategoryData[0]?.name)}>
              <div className="category-card d-flex flex-column justify-content-center py-2 large" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[0]?.logo_upload})` }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[0]?.logo}/></svg>
                <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[0]?.name}</h3>
                {/* <p className="text-light">Let's celebrate together new year.</p> */}
                {/* <span className="count">12</span> */}
              </div>
            </div>
            <div className="ccol-12 col-sm-12 col-md-6 col-lg-2 col-xl-2 col-xxl-2 col-anim w-lg-2 featuredCard" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[1]?.id , Array.isArray(props.CategoryData) && props.CategoryData[1]?.name)}>
              <div className="category-card d-flex flex-column justify-content-start py-4 large" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[1]?.logo_upload})` }}>
                <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[1]?.logo}/></svg>
                <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[1]?.name}</h3>
                {/* <span className="count">12</span> */}
              </div>
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-6 col-xl-6 col-xxl-6">
              <div className="row g-3">
                <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 col-anim w-md-8 wideCard" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[2]?.id , Array.isArray(props.CategoryData) && props.CategoryData[2]?.name)}>
                  <div className="category-card d-flex flex-column justify-content-center py-4 small" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[2]?.logo_upload})` }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[2]?.logo}/></svg>
                    <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[2]?.name}</h3>
                    {/* <span className="count">48</span> */}
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 col-anim w-md-4 miniCard" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[3]?.id ,Array.isArray(props.CategoryData) && props.CategoryData[3]?.name)}>
                  <div className="category-card py-4 small" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[3]?.logo_upload})` }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[3]?.logo}/></svg>
                    <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[3]?.name}</h3>
                    {/* <span className="count">17</span> */}
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 col-anim w-md-4 miniCard-2" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[4]?.id , Array.isArray(props.CategoryData) && props.CategoryData[4]?.name)}>
                  <div className="category-card py-4 medium" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[4]?.logo_upload})` }}> 
                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[4]?.logo}/></svg>
                    <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[4]?.name}</h3>
                    {/* <span className="count">09</span> */}
                  </div>
                </div>
                <div className="col-12 col-sm-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 col-anim w-md-8 wideCard-2" onClick={(e) => handleCategoryDetails(e, Array.isArray(props.CategoryData) && props.CategoryData[5]?.id , Array.isArray(props.CategoryData) && props.CategoryData[5]?.name)}>
                  <div className="category-card d-flex flex-column justify-content-center py-4 medium" style={{ backgroundImage: `url(${Array.isArray(props.CategoryData) && props.CategoryData[5]?.logo_upload})` }}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="40px" viewBox="0 -960 960 960" width="40px" fill="#fff"><path d={Array.isArray(props.CategoryData) && props.CategoryData[5]?.logo}/></svg>
                    <h3 className="category-title">{Array.isArray(props.CategoryData) && props.CategoryData[5]?.name}</h3>
                    {/* <span className="count">55</span> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>


      {/* Quick Filter Section */}
      <section className="quick-filter-section py-4 animate-section d-none">
        <div className="container">
  
          {/* <div className="section__heading mb-2">
            <div>
              <h3 className="section__heading--maintitle" style={{ display: 'inline-block' }}>Quick Search</h3>
            </div>
            <div className="title-line"></div>
          </div> */}
        
          <div className="row pt-3">

            {Array.isArray(props.CategoryData) && props.CategoryData.map((item) => (
              <div className="col-6 col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-2 my-3"
                onClick={(e) => handleCategoryDetails(e, item.id, item.name)} >
                <div className="p-4 quick-search-card">
                  <img className="mb-1 quick-img" src={item.logo_upload} alt="" />
                  <h3 className="m-0 overflow-text quick-title">{item.name}</h3>
                </div>
              </div>
            ))}
            
          </div>

        </div>
      </section>

       <section className="product__section color-scheme-3 py-4 animate-section nw-gradient-bg-light-dark-wine mb-4">
        {/* <div className="container">
            <h4 className="h4 d-flex"> PASSILO is India’s first fully integrated registration platform for running events. Beside
              being a registration platform for running events, we also provide technology solutions,
              back office service and go-to-market offerings to grow your running event.</h4>
              <br/>
              <br/>
        </div> */}
        <div className="container">
          <div className="section__heading mb-2">
           

            <div className='row'>
              <div className='col-12 col-sm-8 col-md-8 col-lg-10 col-xl-10 col-xxl-10'>
                {/* <h3 className="section__heading--maintitle" style={{ display: 'inline-block' }}>Recently Added Events</h3>
                  <p style={{ display: 'inline-block', filter: 'blur(0.3px)', marginLeft: '10px' }}>In {HeaderCity}</p> */}
                <h3 className="section__heading--maintitle" style={{ display: 'inline-block' }}>Featured Events</h3>
              </div>
              <div className="col-12 col-sm-4 col-md-4 col-lg-2 col-xl-2 col-xxl-2">
                <div className="event-visibility hand_cursor d-none d-sm-flex" style={{ width: "fit-content", float: "right" }} onClick={(e) =>
                  SearchFilter(e)}>
                  {eventsData && eventsData.length > 0 ?
                    <div className="visibility gap-1 ">
                      View All
                      <svg xmlns="http://www.w3.org/2000/svg" height={20} viewBox="0 -960 960 960" width={20}>
                        <path d="m560-240-56-58 142-142H160v-80h486L504-662l56-58 240 240-240 240Z" />
                      </svg>
                    </div>
                  : null }
                </div>
              </div>
            </div>

           
            <div className="title-line3"></div>
          </div>
          {/* {
            (props.FewSuggestionFlag === 1) && (eventsData.length > 0) ?
              <>
                <div className="product__section--inner py-5 text-center">
                  <img src={NoEventImg} alt="" style={{ width: 250 }} />
                  <h4 className="pt-4">No events found</h4>
                  <p>
                    Sorry, We couldn't find any events that match your search, but here are some
                    suggestions!
                  </p>
                </div>
              </> : null
          } */}

          <div className="product__section--inner product__swiper--column4 swiper pt-0 pb-5 desktop-view-event" >
            <div className="swiper-wrapper">

              {eventsData.length <= 4 && ConditionFlag == 0 ?
                <div className="swiper-slide popular-events">

                  <div className='row py-4  px-3'>
                    {
                      eventsData.length > 0 ?

                        Array.isArray(eventsData) && eventsData.map((event, index) => (
                          <div className='col-12 col-sm-6 col-md-6 col-xl-3 col-xxl-3 py-3 ' style={{ paddingRight: '8px', paddingLeft: '8px' }} key={index} >
                            <div className="product__items"
                              onClick={(e) => handleEventDetails(e, event.id, event.name)}
                            >

                              <div className="product__items--thumbnail" >
                                <div className="product__items--link">
                                  <img
                                    className="product__items--img product__primary--img"
                                    src={event.banner_image || EventView}
                                    alt="Event View"
                                    style={{ height: '230px', objectFit: 'fill' }}
                                  />
                                </div>


                                {/* {event.TicketDetails && event.TicketDetails.length > 0 && (
                                  event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (
                                    <div className="product__badge style1 special-badge gap-1">
                                      Early Bird
                                    </div>
                                  ) : null
                                )} */}
                                {/* New Event date */}
                                <div className='event-date-card'>
                                  <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                                  <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                                </div>
                                
                                <div className="product__badge style1 special-badge gap-1" >
                                  <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city_name}
                                </div>


                                {event.TicketDetails && event.TicketDetails.length > 0 && (
                                  event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                    <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                      {/* Early Bird */}
                                      <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                    </div>
                                  ) : null
                                )}

                              
                              </div>


                              {/* event info */}
                              <div className="product__items--content cursor-pointer" >

                                <div className=" pt-2">
                                  <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.display_name}</h4>
                                </div>

                                {/* Location and like & share btn */}
                                <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                                  <div className="col-sm-7">
                                    {event.venue ?
                                      <p className='card-rgn-txt overflow-text'> <strong>
                                        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                      </p>
                                    : null }
                                  </div>

                                  <div className="col-sm-5 ps-0">
                                    <ul className="product__items--action d-flex justify-content-end">

                                      {/* Wishlist */}
                                      <li className="product__items--action__list ">
                                        <div className={event.is_follow ? "hand_cursor product__items--action__btn wishlisted" : "hand_cursor product__items--action__btn action-favourites"} onClick={(e) => {
                                          e.stopPropagation(); // Stop event propagation
                                          handleWishList(event.id, event.is_follow);
                                        }}>


                                          <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>

                                          <span className="visually-hidden">Favourites</span>
                                        </div>
                                      </li>

                                      <li className="product__items--action__list">
                                        <div className="product__items--action__btn hand_cursor action-share" onClick={(e) => {
                                          e.stopPropagation();
                                          handleShareEvent(event.id, event.name)
                                        }}>


                                          <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z" /></svg>


                                          <span className="visually-hidden">Compare</span>
                                        </div>
                                      </li>
                                    </ul>
                                  </div>
                                </div>


                                {/* amount and action btn */}
                                <div className="d-flex align-items-center justify-content-between py-3 px-2">
                                  
                                  <div className="">
                                    {event.other_platform === 0 &&
                                    event.TicketDetails?.length > 0 ? (
                                      <h4 className="h4 d-flex align-items-center gap-1">
                                        
                                        {/* Currency Icon */}
                                        {/* {!event.TicketDetails.some(
                                          ticket => Number(ticket.ticket_status) === 2
                                        ) && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="22px"
                                            viewBox="0 -960 960 960"
                                            width="22px"
                                            fill="currentColor"
                                          >
                                            <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                                          </svg>
                                        )} */}

                                        {/* {event.TicketDetails.some(
                                          ticket => Number(ticket.ticket_status) === 2
                                        ) ? (
                                          <span>Free</span>
                                        ) : (
                                          <>
                                            {event.TicketDetails
                                              .filter(ticket => Number(ticket.ticket_status) === 1)
                                              .map((ticket, index, arr) => (
                                                <span key={index}>
                                                  {ticket.ticket_price}
                                                  {index < arr.length - 1 && " - "}
                                                </span>
                                              ))}
                                            <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                          </>
                                        )} */}
                                        {event.TicketDetails && event.TicketDetails.length > 0 && (
                                          event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                            <span className="current__price m-0">Free</span>
                                          ) : (
                                            event.TicketDetails.map((ticket, index) => (
                                              parseInt(ticket.ticket_status) === 1 && (
                                                <span key={index}>
                                                  {index > 0 && " - "}
                                                  {ticket.show_early_bird === 1 ? (
                                                    <span className="text-left">
                                                      <span className="ticket-prices">
                                                        <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                        <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                  )}
                                                  <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                </span>
                                              )
                                            ))
                                          )
                                        )}
                                      </h4>
                                    ) : null}
                                  </div>
                                  
                                  {event.registration_close_flag == 0 ?
                                    <div className="">
                                      
                                      <h4 className="h4 register-btn-link">Register Now <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>

                                      <div className='product__items--action__btn hand_cursor register-btn-icon'> 
                                        <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>
                                      </div>
                                      
                                    </div>
                                  :
                                    <p className="m-0 p-1 text-danger"><svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg> Registration Closed</p>
                                  }
                                </div>

                              </div>
                            </div>
                          </div>

                        ))

                        :
                        <>
                          <div className="product__section--inner py-5 text-center">
                            <img src={NoEventImgLight} alt="" style={{ width: 250 }} />
                            <h4 className="pt-4 text-light">Oops! No Events Found</h4>
                            <p className='text-light mb-1'>Sorry, We couldn't find any events that match your search.</p>
                            <h4 className="h4 register-btn-link text-light d-block" onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')} style={{cursor: 'pointer'}} onClick={(e) => props.setCountryFlag(true)}>Explore All Events <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>                             
                          </div>
                        </>
                    }
                  </div>

                </div>

                : ConditionFlag === 1 ?

                   <div className="swiper-slide popular-events">

                    <Slider {...settings}>
                      {Array.isArray(eventsData) && eventsData.map((event, index) => (

                        <div key={index} className="product__items "
                          onClick={(e) => handleEventDetails(e, event.id, event.name)}
                        // style={{visibility: event.visibility}}
                        >
                          <div className="product__items--thumbnail" >
                            <div className="product__items--link">
                              <img
                                className="product__items--img product__primary--img"
                                src={event.banner_image || EventView}
                                alt="Event View"
                                style={{ height: '230px', objectFit: 'fill' }}
                              />
                            </div>


                            {/* New Event date */}
                            <div className='event-date-card'>
                              <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                              <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                            </div>

                            <div className="product__badge style1 special-badge gap-1" >
                              <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city_name}
                            </div>

                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                              event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                  {/* Early Bird */}
                                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                </div>
                                
                              ) : null
                            )}
                            
                          </div>

                          {/* event info */}
                          <div className="product__items--content cursor-pointer" >
                            
                            {/* <div className='my-3 d-flex gap-3'>
                              <small className="m-0 card-event-city">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    height={17}
                                    viewBox="0 -960 960 960"
                                    width={17}
                                >
                                    <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" />
                                </svg> {event.city_name}</small>
                            </div> */}


                            {/* Event Name */}
                            <div className=" pt-2">
                              <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.display_name}</h4>
                            </div>

                                 
                            {/* Location and like & share btn */}
                            <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                              <div className="col-sm-7">
                                {event.venue ?
                                <p className='card-rgn-txt overflow-text'> <strong>
                                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                                </p>  : null }
                                
                              </div>

                              <div className="col-sm-5 ps-0">
                                <ul className="product__items--action d-flex justify-content-end">

                                  {/* Wishlist */}
                                  <li className="product__items--action__list ">
                                    <div className={event.is_follow ? "hand_cursor product__items--action__btn wishlisted" : "hand_cursor product__items--action__btn action-favourites"} onClick={(e) => {
                                      e.stopPropagation(); // Stop event propagation
                                      handleWishList(event.id, event.is_follow);
                                    }}>


                                      <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>

                                      <span className="visually-hidden">Favourites</span>
                                    </div>
                                  </li>

                                  <li className="product__items--action__list">
                                    <div className="product__items--action__btn hand_cursor action-share" onClick={(e) => {
                                      e.stopPropagation();
                                      handleShareEvent(event.id, event.name)
                                    }}>


                                      <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z" /></svg>


                                      <span className="visually-hidden">Compare</span>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </div>
                           
                            <div className="amt-action-div py-3 px-0">
                              <div className="">
                                {event.other_platform === 0 &&
                                    event.TicketDetails?.length > 0 ? (
                                      <h4 className="h4 d-flex align-items-center gap-1">
                                        
                                        {/* Currency Icon */}
                                        {!event.TicketDetails.some(
                                          ticket => Number(ticket.ticket_status) === 2
                                        ) && (
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            height="22px"
                                            viewBox="0 -960 960 960"
                                            width="22px"
                                            fill="currentColor"
                                          >
                                            <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                                          </svg>
                                        )}

                                        {/* {event.TicketDetails.some(
                                          ticket => Number(ticket.ticket_status) === 2
                                        ) ? (
                                          <span>Free</span>
                                        ) : (
                                          <>
                                            {event.TicketDetails
                                              .filter(ticket => Number(ticket.ticket_status) === 1)
                                              .map((ticket, index, arr) => (
                                                <span key={index}>
                                                  {ticket.ticket_price}
                                                  {index < arr.length - 1 && " - "}
                                                </span>
                                              ))}
                                            <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                          </>
                                        )} */}
                                         {event.TicketDetails && event.TicketDetails.length > 0 && (
                                          event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                            <span className="current__price m-0">Free</span>
                                          ) : (
                                            event.TicketDetails.map((ticket, index) => (
                                              parseInt(ticket.ticket_status) === 1 && (
                                                <span key={index}>
                                                  {index > 0 && " - "}
                                                  {ticket.show_early_bird === 1 ? (
                                                    <span className="text-left">
                                                      <span className="ticket-prices">
                                                        <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                        <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                  )}
                                                  <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                </span>
                                              )
                                            ))
                                          )
                                        )}
                                      </h4>
                                    ) : null}
                              </div>
                              {event.registration_close_flag == 0 ?
                                <div className="">

                                  <h4 className="h4 register-btn-link">Register Now <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>
                                  
                                  <div className='product__items--action__btn hand_cursor register-btn-icon'> 
                                    <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg>
                                  </div>

                                </div>
                              :
                                <p className="m-0 p-1 text-danger"><svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg> Registration Closed</p>
                              }

                            </div>

                          </div>
                        </div>
                      ))}
                    </Slider>
                  </div>
                  :
                  
                  <div className="product__section--inner py-5 text-center w-100">
                    <img src={NoEventImgLight} alt="" style={{ width: 250 }} />
                    <h4 className="pt-4 text-light">Oops! No Events Found</h4>
                    <p className='text-light mb-1'>Sorry, We couldn't find any events that match your search.</p>
                    <h4 className="h4 register-btn-link text-light" onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')} onClick={(e) => props.setCountryFlag(true)}>Explore All Events <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>
                  </div>

              }

            </div>
          </div>
          {/* {console.log(eventsData)} */}
           {/* Mobile view responsive */}
          <div className="mob-view-event">

            {eventsData && eventsData.length > 0 ?
              Array.isArray(eventsData) && eventsData.slice(0, 4).map((event, index) => (
              // Array.isArray(eventsData) && eventsData.map((event) => (
                <>
                   <div className='col-12 col-sm-12 col-md-6 col-xl-3 col-xxl-3 py-3 ' style={{ paddingRight: '8px', paddingLeft: '8px' }} key={index} >
                    <div className="product__items "
                              onClick={(e) => handleEventDetails(e, event.id, event.name)}
                            >
                      <div className="product__items--thumbnail" >
                        <div className="product__items--link">
                          <img
                            className="product__items--img product__primary--img"
                            src={event.banner_image || EventView}
                            alt="Event View"
                            style={{ height: '230px', objectFit: 'fill' }}
                          />
                        </div>

                        {/* New Event date */}
                        <div className='event-date-card'>
                          <p className="m-0 event-month-value">{event.start_event_month ? event.start_event_month : null}</p>
                          <p className="m-0 event-date-value">{event.start_event_date ? event.start_event_date : null}</p>
                        </div>
                            
                            <div className="product__badge style1 special-badge gap-1" >
                              <svg xmlns="http://www.w3.org/2000/svg" height="15px" viewBox="0 -960 960 960" width="15px" fill="#323131ff"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> {event.city_name}
                            </div>

                            {event.TicketDetails && event.TicketDetails.length > 0 && (
                                  event.TicketDetails.some(ticket => (parseInt(ticket.show_early_bird) === 1 && parseInt(ticket.ticket_status) !== 2)) ? (

                                <div className="product__badge_early_bird style1 special-badge gap-1" title='Early Bird'>
                                  {/* Early Bird */}
                                  <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#ffffff"><path d="M480-80q-24 0-46-9t-39-26q-29-29-50-38t-63-9q-50 0-85-35t-35-85q0-42-9-63t-38-50q-17-17-26-39t-9-46q0-24 9-46t26-39q29-29 38-50t9-63q0-50 35-85t85-35q42 0 63-9t50-38q17-17 39-26t46-9q24 0 46 9t39 26q29 29 50 38t63 9q50 0 85 35t35 85q0 42 9 63t38 50q17 17 26 39t9 46q0 24-9 46t-26 39q-29 29-38 50t-9 63q0 50-35 85t-85 35q-42 0-63 9t-50 38q-17 17-39 26t-46 9Zm100-240q25 0 42.5-17.5T640-380q0-25-17.5-42.5T580-440q-25 0-42.5 17.5T520-380q0 25 17.5 42.5T580-320Zm-202-2 260-260-56-56-260 260 56 56Zm2-198q25 0 42.5-17.5T440-580q0-25-17.5-42.5T380-640q-25 0-42.5 17.5T320-580q0 25 17.5 42.5T380-520Z" /></svg>
                                </div>
                              ) : null
                            )}

                      </div>

                      {/* event info */}
                      <div className="product__items--content cursor-pointer" >

                        {/* Event Name */}
                        <div className=" pt-2">
                          <h4 className="h4 d-flex" style={{ height: "55px", overflow: "hidden" }}>  {event.display_name}</h4>
                        </div>

                        {/* Location and like & share btn */}
                        <div className="row d-flex align-items-center py-3" style={{ borderBottom: "1px dashed #c7c7c7" }}>
                          <div className="col-7 col-sm-7">
                            {event.venue ?
                              <p className='card-rgn-txt overflow-text'> <strong>
                                <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="#383434"><path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0 33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127 0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z" /></svg> <span className="rgn-date">{event.venue}</span></strong>
                              </p>
                             : null }
                          </div>

                          <div className="col-5 col-sm-5 ps-0">
                            <ul className="product__items--action d-flex justify-content-end">

                              {/* Wishlist */}
                              <li className="product__items--action__list ">
                                <div className={event.is_follow ? "hand_cursor product__items--action__btn wishlisted" : "hand_cursor product__items--action__btn action-favourites"} onClick={(e) => {
                                  e.stopPropagation(); // Stop event propagation
                                  handleWishList(event.id, event.is_follow);
                                }}>


                                  <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94 0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Z" /></svg>

                                  <span className="visually-hidden">Favourites</span>
                                </div>
                              </li>

                              <li className="product__items--action__list">
                                <div className="product__items--action__btn hand_cursor action-share" onClick={(e) => {
                                  e.stopPropagation();
                                  handleShareEvent(event.id, event.name)
                                }}>


                                  <svg className="product__items--action__btn--svg" xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 -960 960 960" width="18px" transform="translate(0 0)" fill="currentColor"><path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Z" /></svg>


                                  <span className="visually-hidden">Compare</span>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>

                        {/* amount and action btn */}
                        <div className="amt-action-div py-3 px-2">
                          <div className="">
                            {event.other_platform === 0 &&
                                event.TicketDetails?.length > 0 ? (
                                  <h4 className="h4 d-flex align-items-center gap-1">
                                    
                                    {/* Currency Icon */}
                                    {/* {!event.TicketDetails.some(
                                      ticket => Number(ticket.ticket_status) === 2
                                    ) && (
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        height="22px"
                                        viewBox="0 -960 960 960"
                                        width="22px"
                                        fill="currentColor"
                                      >
                                        <path d="M549-120 280-400v-80h140q53 0 91.5-34.5T558-600H240v-80h306q-17-35-50.5-57.5T420-760H240v-80h480v80H590q14 17 25 37t17 43h88v80h-81q-8 85-70 142.5T420-400h-29l269 280H549Z" />
                                      </svg>
                                    )}

                                    {event.TicketDetails.some(
                                      ticket => Number(ticket.ticket_status) === 2
                                    ) ? (
                                      <span>Free</span>
                                    ) : (
                                      <>
                                        {event.TicketDetails
                                          .filter(ticket => Number(ticket.ticket_status) === 1)
                                          .map((ticket, index, arr) => (
                                            <span key={index}>
                                              {ticket.ticket_price}
                                              {index < arr.length - 1 && " - "}
                                            </span>
                                          ))}
                                        <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                      </>
                                    )} */}
                                     {event.TicketDetails && event.TicketDetails.length > 0 && (
                                          event.TicketDetails.some(ticket => parseInt(ticket.ticket_status) === 2) ? (
                                            <span className="current__price m-0">Free</span>
                                          ) : (
                                            event.TicketDetails.map((ticket, index) => (
                                              parseInt(ticket.ticket_status) === 1 && (
                                                <span key={index}>
                                                  {index > 0 && " - "}
                                                  {ticket.show_early_bird === 1 ? (
                                                    <span className="text-left">
                                                      <span className="ticket-prices">
                                                        <span className="original-price"> ₹{ticket.ticket_price}</span>&nbsp;
                                                        <span className="current__price m-0">₹{ticket.discount_ticket_price}</span>
                                                      </span>
                                                    </span>
                                                  ) : (
                                                    <span className="current__price m-0">₹{ticket.ticket_price}</span>
                                                  )}
                                                  <small className="fw-normal fs-5 mt-1"> Onwards</small>
                                                </span>
                                              )
                                            ))
                                          )
                                        )}
                                  </h4>
                                ) : null}
                          </div>
                          {event.registration_close_flag == 0 ?
                            <div className="">
                              <h4 className="h4 register-btn-link">Register Now <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>
                            </div>
                          :
                            <p className="m-0 p-1 text-danger"><svg style={{ fill: "#dc3545" }} xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 -960 960 960" width="20px" fill="#dc3545"><path d="M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q54 0 104-17.5t92-50.5L228-676q-33 42-50.5 92T160-480q0 134 93 227t227 93Zm252-124q33-42 50.5-92T800-480q0-134-93-227t-227-93q-54 0-104 17.5T284-732l448 448Z" /></svg> Registration Closed</p>
                          }
                        </div>

                      </div>
                    </div>
                  </div>

                </>

              ))

              :
                <div className="product__section--inner py-5 text-center w-100">
                  <img src={NoEventImgLight} alt="" style={{ width: 250 }} />
                  <h4 className="pt-4 text-light">Oops! No Events Found</h4>
                  <p className='text-light mb-1'>Sorry, We couldn't find any events that match your search.</p>
                  <h4 className="h4 register-btn-link text-light" onMouseOver={e => (e.target.style.fontWeight = 'bold')} onMouseOut={e => (e.target.style.fontWeight = 'normal')} onClick={(e) => props.setCountryFlag(true)}>Explore All Events <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px" fill="currentColor"><path d="M647-440H160v-80h487L423-744l57-56 320 320-320 320-57-56 224-224Z" /></svg></h4>
                </div>
            }

            {eventsData && eventsData.length > 0 ?
              <div className="col-sm-12 my-3 text-center" onClick={(e) => handleSearchPage(e)} style={{ cursor: 'pointer' }}>
                <p className="blog__content--btn primary__btn">View All</p>
              </div>
              : null}

          </div>

        </div>
      </section>

    </>
  )
}

export default FeaturedEvents;

